
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"id":"image0","width":"32","height":"27","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOJSURBVHgB7ZZbaBxVGMd/u7ntbtK95NZUzYbdQLUBmyYtKtXGomJeiiAl0TeR+qAvCoaC5EFqsdjqqyLSILb4UCoFK2KTXqA0TU2TTZqN7e52N5ukSZrEuJfsLbubvYxnplDEJm2mFNqH/GGY831z5v/953++wxlYxzoeMzQrJXV7jllf31HdqYUSHkURrSblnYt2eb5vH1rDdElz+OTwiHQf5PN5aWExKU3MR5UrGE1KD0JXjyshc/+/WuE99Xd/UfC87X3LavIS6SzHL3jRFRVgKSvBN7tI99AMW23lfNbWxEazfsX3mu1VxTI3F8neX8ADcOjENT5ofVYZ22uMjM9H2ffmFnZ8corpf+Ic//Q1DLq102pRAd9shJcbNnLp+hx7D51Vch1d/Zzun+Tbj3Zxqm+CK555NZTqBNwOJGi0VdAzPHM3J5aXn857ea7WpMQ3boVRA1UCNhiKCMfTivX/hbW6lFAsrYzlvlADVT2wzV5J57EBOtubKC68o/2tl+rYu9POh9/1Ur/JyJ4XrGoo1TlQoNXwbku9sPwmbbvsiv2vNNTw+c8OrvkDHP24hfINOjWUqwuQyUedTryem4h9TyAQUPJN9ZW898Zmxm5HOHHJz8XROXY2VPN7Zwvm7N9c6esjFospcy/3XuahBcjweb2YLGa+OXKEmelphoeGmJqaYtLrwmaIsrksQusWPW+/aKX3whmamptJJpPc+Os6fr8fn8+Lc2SEfC6nXoBGo0ESd6PRSCKeoPuPM4z7x/n6q8OC1Mlvv54mEg5ztqeHbDZLPHrnq0tLSxkb8+EYGCAYDBKJRHA4HKuVWb0JFxYWyCxncLtctL3TjtvtpmZTDc3bt2M2m4RAqLVayWSy6PV6Wna/ysDVq2i1WqqqqkimUtTb7ZhMJurq6pgI5tQJKCwsZHTUSS6fIxgIKgU9QkRmeVnYvERRcTGDg4PCnThfHjyIQW/AXG5BHBTERM5itlCiK+H8uXN07N+PIFEnYGlpSbE2FAzRuK2RUCiERzSkTpCGhfUVFZXcmpxEPlCLhNinnnmaeCwuLF+krKxMLMMY6XRKcUPuGzCwZvzQ7R6RT7xoNKqcfIlEQkqn01JMxPF4XBKNdjeWn8k5OZbvwiFlLM9JpVKS2BFKfLLXn+DAgXt6buX/gbajttattR35nFTKI0BOItvvmv0x9Mu+P1nHOp40/Asxcucxlua3NQAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    